export { default as Layout } from "@theme-hope/layouts/base/Layout";
export { default as NotFound } from "@theme-hope/layouts/base/NotFound";
